<template>
  <AGCard class="ag-indicador-linha" has-rounded-top>
    <template v-if="!isFetching" #header>
      <div class="d-flex align-center justify-space-between mb-4 w-100">
        <AGTruncatedText>{{ title }}</AGTruncatedText>
        <v-spacer></v-spacer>
        <AGTooltip
          v-if="tooltip"
          large-tooltip-icon="mdi-information-outline"
          large-tooltip-title="Informação"
          :large-tooltip="true"
        >
          <template #largeTooltipContent>
            <div v-html="tooltip"></div>
          </template>
          <div class="d-flex align-center">
            <AGIcon icon="md:info" size="24px" />
          </div>
        </AGTooltip>
      </div>
    </template>
    <div v-if="!isFetching">
      <div class="ag-indicador-linha__conteudo">
        <div class="ag-indicador-linha__total">
          {{ total }}
        </div>
        <div class="ag-indicador-linha__item">
          <div class="d-flex flex-row">
            <div class="ag-indicador-linha__item--label">
              <v-badge location="left" dot inline floating :color="items[0].color"></v-badge>
              {{ items[0].label }} ({{ items[0].value }})
            </div>
          </div>
          <div class="d-flex flex-row mt-4">
            <div class="ag-indicador-linha__item--label">
              <v-badge location="left" dot inline floating :color="items[1].color"></v-badge>
              {{ items[1].label }} ({{ items[1].value }})
            </div>
          </div>
        </div>
        <div class="ag-indicador-linha__grafico">
          <div class="d-flex flex-row align-center">
            <span class="text-neutral-color-high-medium">{{ porcentagemItem1 }}%</span>
            <v-progress-linear
              class="mx-2"
              bg-opacity="1"
              height="16px"
              rounded
              :color="items[0].color"
              :bg-color="items[1].color"
              :model-value="porcentagemItem1"
            />
            <span class="text-neutral-color-high-medium">{{ porcentagemItem2 }}%</span>
          </div>
        </div>
      </div>
    </div>
    <v-skeleton-loader v-else height="146px" type="chip, sentences, text" />
  </AGCard>
</template>

<script>
import AGCard from '@/components/common/AGCard.vue';
import AGIcon from '@/components/common/AGIcon.vue';
import AgTooltipOld from '@/components/common/AGTooltipOld.vue';
import AGTruncatedText from '@/components/common/AGTruncatedText.vue';

export default {
  components: {
    AGTruncatedText,
    AGIcon,
    AGTooltip: AgTooltipOld,
    AGCard,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    tooltip: {
      type: String,
      default: null,
    },
    isFetching: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    total() {
      return this.items[0].value + this.items[1].value;
    },
    porcentagemItem1() {
      return Math.round((this.items[0].value / this.total) * 100);
    },
    porcentagemItem2() {
      return Math.round((this.items[1].value / this.total) * 100);
    },
  },
};
</script>

<style scoped lang="scss">
.ag-indicador-linha {
  .ag-indicador-linha__conteudo {
    display: flex;
    flex-wrap: wrap;
    align-items: end;

    .ag-indicador-linha__total {
      color: $neutral-color-high-medium;
      font-size: 64px;
      line-height: 1;
      margin-right: $spacing-05;
    }

    .ag-indicador-linha__item--label {
      color: $neutral-color-high-medium;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .ag-indicador-linha__item {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

    .ag-indicador-linha__grafico {
      width: 100%;
      margin-top: 10px;
    }
  }
}
</style>
